import React from 'react'
import PropTypes from 'prop-types'

import UserSidebarScrollablePills from './UserSidebarScrollablePills'

function UserSidebarPills({ items, keyPrefix, title }) {
  return (
    <section className="user-data__section">
      <div className="l-inner">
        <h4 className="heading-16 text-bold u-mt0">{title}</h4>
        <div className="user-data__section--scrollable">
          <div className="job-list-item__row user-profile__row">
            <UserSidebarScrollablePills
              items={items}
              keyPrefix="software"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

UserSidebarPills.propTypes = {
  keyPrefix: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
}

export default UserSidebarPills
